import { apiService } from './api'

class ScheduledMessageService {
  async getScheduledMessages(params?: any) {
    const response = await apiService.api.get('/admin/scheduled-messages', { params })
    return response.data
  }

  async getStats() {
    const response = await apiService.api.get('/admin/scheduled-messages/stats')
    return response.data
  }

  async getById(id: number) {
    const response = await apiService.api.get(`/admin/scheduled-messages/${id}`)
    return response.data
  }

  async create(data: any) {
    const isFormData = data instanceof FormData
    const response = await apiService.api.post('/admin/scheduled-messages', data, {
      headers: isFormData ? { 'Content-Type': null as any } : undefined
    })
    return response.data
  }

  async update(id: number, data: any) {
    const isFormData = data instanceof FormData
    const response = await apiService.api.put(`/admin/scheduled-messages/${id}`, data, {
      headers: isFormData ? { 'Content-Type': null as any } : undefined
    })
    return response.data
  }

  async cancel(id: number) {
    const response = await apiService.api.patch(`/admin/scheduled-messages/${id}/cancel`)
    return response.data
  }

  async sendNow(id: number) {
    const response = await apiService.api.post(`/admin/scheduled-messages/${id}/send-now`)
    return response.data
  }

  async delete(id: number) {
    const response = await apiService.api.delete(`/admin/scheduled-messages/${id}`)
    return response.data
  }
}

export const scheduledMessageService = new ScheduledMessageService()
export default scheduledMessageService
